import * as React from 'react';
import clsx from 'clsx';

export interface TabsProps extends React.ComponentPropsWithoutRef<'div'> {
  //
}

export function Tabs({
  children,
  className,
  ...props
}: TabsProps): JSX.Element {
  return (
    <div
      {...props}
      className={clsx('rounded-xl border bg-gray-50 p-1.5', className)}
    >
      {children}
    </div>
  );
}

type TabButtonProps = {
  children: React.ReactNode;
  active?: boolean;
  onClick?: () => void;
  className?: string;
};

export function TabButton({
  children,
  active,
  onClick,
  className,
}: TabButtonProps) {
  return (
    <button
      className={clsx(
        `px-3 py-2.5 text-md font-semibold hover:text-gray-950`,
        active
          ? `rounded-sm bg-white text-gray-700 shadow-sm`
          : `text-gray-500`,
        className,
      )}
      onClick={onClick}
      type="button"
    >
      {children}
    </button>
  );
}
